import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm} from 'redux-form'
import FormFieldText from '../../../components/uiKit/FormFieldText'
import Button from '../../../components/uiKit/Button'
import ReCaptchaField from '../ReCaptchaField'
import AppleLogin from 'react-apple-login'

const required = value => value ? undefined : 'Please choose a password to sign-in to Plickers with.'

class AddPasswordToAppleForm extends React.Component{
	render(){
		return(			
			<form onSubmit={this.props.handleSubmit} autoComplete='off'>				    				    			          
				<Field 
					name='email'
					type='text'
					component={FormFieldText}
					disabled
					size='large'
				/>
				<Field 
					name='newPassword'
					type='password'
					label='Password'
					component={FormFieldText}	
					autoFocus={true}        
					validate={[required]}				        
					size='large'
					subLabel='Choose a password. Your password must be at least 6 characters.'
				/>
				<Field name='recaptchaResponse' component={ReCaptchaField}/> 
				<div className='accountForm-actionRow'>						
					<AppleLogin 
						clientId={process.env.REACT_APP_SIGN_IN_WITH_APPLE_CLIENT_ID} 
						redirectURI={process.env.REACT_APP_SIGN_IN_WITH_APPLE_REDIRECT_URI}
						usePopup={true} 
						callback={this.props.addPassword}
						scope={"email name"}
						responseType={"query"}
						render={(props)=>{return(
							<Button
								onClickFunction={props.onClick}
								size='xLarge'
								label='Authenticate with Apple to Confirm'
								color={this.props.dirty && this.props.valid ? 'blue' : 'gray'}
								canSubmit={this.props.dirty && this.props.valid ? true : false}
							/>
						)}}
					/>	
				</div>
			</form>			 
		)
	}
}

const mapStateToProps = (state,ownProps) => {
	return {
		initialValues: {
			email:ownProps.email,
		}
	}
}

AddPasswordToAppleForm = reduxForm({
	form: 'addPasswordForm',
	enableReinitialize: true,
	autoComplete:'off'
})(AddPasswordToAppleForm)

export default connect(mapStateToProps)(AddPasswordToAppleForm)